export class GridSettings {
  public pageSize: number = 10;
  public sortField: string = '';
  public sortAsc: boolean = true;
}
